import { Component, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { error: Error | null };

export default class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: { componentStack?: string | null }): void {
    console.error("[Swift] render error:", error, info.componentStack);
  }

  override render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="flex h-full items-center justify-center p-6">
          <div className="max-w-2xl space-y-3 rounded-lg border border-red-700 bg-red-950/40 p-5 text-sm text-red-100">
            <div className="text-base font-semibold text-red-200">
              Er ging iets mis in de Swift-UI
            </div>
            <pre className="whitespace-pre-wrap break-words rounded bg-black/30 p-3 text-xs">
              {this.state.error.name}: {this.state.error.message}
              {this.state.error.stack ? `\n\n${this.state.error.stack}` : ""}
            </pre>
            <button
              onClick={() => location.reload()}
              className="rounded bg-red-700 px-3 py-1 text-white hover:bg-red-600"
            >
              Herlaad
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
